export enum USER_TYPES {
  A = 'Admin',
  C = 'Client',
  E = 'External',
  I = 'Internal'
};
